import { Alert } from 'doctornow-design-system';

interface PaidQuestionTerminationNoticeProps {
  terminationDate: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const PaidQuestionTerminationNoticeModal = (props: PaidQuestionTerminationNoticeProps) => {
  const handleConfirm = () => {
    props.onOpenChange(false);
  };

  return (
    <Alert
      className={'min-w-[336px]'}
      type='single'
      title={''}
      open={props.open}
      onOpenChange={props.onOpenChange}
      buttons={[
        {
          label: '확인',
          buttonColor: 'primary',
          buttonStyle: 'contained',
          onClick: handleConfirm,
        },
      ]}
    >
      <div className='flex flex-col gap-[24px]'>
        <div className='flex justify-center'>
          <img
            src='/images/medical-consultation-notice.png'
            alt='의료진 상담 중단 안내'
            className='h-[158px] w-[247px] object-contain'
          />
        </div>

        <div className='flex flex-col gap-[8px]'>
          <div>
            <p className={'typography-ui-20sb text-gray-800'}>실시간 상담 내 의료진 유료 상담이</p>
            <p className={'typography-ui-20sb text-gray-800'}>{props.terminationDate}부터 중단돼요</p>
          </div>
          <p className='typography-ui-15r text-gray-600 '>
            {
              '더 나은 상담을 준비하기 위해 잠시 중단해요.\n비대면 진료와 실시간 상담 내 AI 답변은\n계속 이용할 수 있어요.'
            }
          </p>
        </div>
      </div>
    </Alert>
  );
};

export default PaidQuestionTerminationNoticeModal;
